import React from "react";
import {useTranslation} from "react-i18next";
import {
    Checkbox,
    FormControlLabel,
    FormGroup,
} from "@mui/material";
import Button from "@mui/material/Button";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOAccordion from "../../fundamentals/CCOAccordion";

interface Props {
    handleFilterChange: (key: string) => void,
    handleResetFilters: () => void,
    filterValues: { [key: string]: { value: any, isActive: boolean } };
}

function C036SearchFilter({ handleFilterChange, handleResetFilters, filterValues }: Props) {
    const { t } = useTranslation();

    return (
        <CCOContainer width={"small"} sx={{ border: 'none' }}>
            <CCOAccordion dataCypress='searchFilterLabel' title={t("search.show_filters")} sx={{
                borderTop: 'none !important',
                backgroundColor: 'transparent',
                '.MuiAccordionSummary-content': { justifyContent: 'flex-end', marginRight: '16px' }
            }}>
                <FormGroup data-cypress='searchFilterForm' sx={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                    <Button data-cypress='searchResetFilterButton' sx={{ width: '100%', height: '42px', 'button': { justifyContent: 'flex-start' } }}
                            onClick={handleResetFilters}>{t("search.reset_filters")}</Button>
                    {Object.keys(filterValues).map((key) => (
                        <FormControlLabel key={key} sx={{ margin: 0, width: { xs: '100%', sm: '50%', xl: '33%' } }}
                                          control={
                                              <Checkbox
                                                  data-cypress={filterValues[key].value}
                                                  checked={filterValues[key].isActive}
                                                  onChange={() => handleFilterChange(key)}
                                              />
                                          }
                                          label={key}
                        />
                    ))}
                </FormGroup>
            </CCOAccordion>
        </CCOContainer>
    );
}

export default C036SearchFilter;
